<template>
  <div class="header">
    <header-tag :title="$PAGE_API.home.children.operationLog.title"></header-tag>
    <div class="time">
      <span>选择时间：</span>
      <div class="select">
        <input
          type="text"
          id="timeFrame"
          placeholder="请选择时间"
        />
      </div>
    </div>
    <div class="search">
      <input
        type="text"
        placeholder="搜索描述关键字/操作账号"
        v-model="keyword"
        @keyup.enter="searchKeyword()"
        @blur="searchKeyword()"
      />
      <a
        href="#"
        @click.prevent="searchKeyword()"
      ><img
          src="@/assets/img/icon/u502.png"
          alt=""
        /></a>
    </div>
    <div class="operationPlatform">
      <select
        name="operationPlatform"
        id="operationPlatform"
        v-model="selOperatPItem"
        @change="changeSelOperatPItem()"
      >
        <option
          :value="item.id"
          v-for="item in operatPlaList"
          :key="item.id"
          v-text="item.name"
          style="height:30px;"
        ></option>
      </select>
    </div>
    <div class="eventType">
      <select
        name="eventType"
        id="eventType"
        v-model="selEventTypeItem"
        @change="changeSelEventTypeItem()"
      >
        <option value="">事件类型</option>
        <option
          :value="item.dictionaryDataId"
          v-for="item in eventTypeList"
          :key="item.dictionaryDataId"
          v-text="item.dataValue"
        ></option>
      </select>
    </div>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from "_c/tagTitle/headerTag";
// 时间
import "@/assets/laydate/laydate.js";
import "@/assets/laydate/theme/default/laydate.css";
import { _eventTypeList } from "@/requests/operationLog";
export default {
  name: "operationLog-header",
  components: {
    HeaderTag
  },
  data() {
    return {
      keyword: "",
      beginDate: null,
      endDate: null,
      operatPlaList: [
        {
          id: "",
          name: "操作平台"
        },
        {
          id: 1,
          name: "web端"
        },
        {
          id: 2,
          name: "远程管理端"
        },
        {
          id: 3,
          name: "手机端"
        }
      ],
      eventTypeList: [],
      selOperatPItem: "",
      selEventTypeItem: "",
      timeQuantum: []
    };
  },
  mounted() {
    this.getOperatPlarformList();
    this.getEventTypeList();
    this.timeFrame("");
  },
  methods: {
    searchKeyword() {
      this.$emit("operationLogSearchKeyword", this.keyword);
    },
    timeFrame(value) {
      /* eslint-disable */
      var _this = this;
      laydate.render({
        elem: "#timeFrame",
        value: value,
        range: "至",
        btns: ["confirm"],
        done(value, date) {
          if (value) {
            _this.timeQuantum = value.split("至");
            _this.beginDate = _this.timeQuantum[0].trim();
            _this.endDate = _this.timeQuantum[1].trim();
            _this.$emit(
              "operationLogDate",
              _this.beginDate,
              _this.endDate
            );
          } else {
            _this.beginDate = "";
            _this.endDate = "";
            _this.$emit(
              "operationLogDate",
              _this.beginDate,
              _this.endDate
            );
          }
        }
      });
    },
    getOperatPlarformList() {
      this.selOperatPItem = this.operatPlaList[0].id;
    },
    async getEventTypeList() {
      let res = await _eventTypeList();
      this.eventTypeList = res;
      this.selEventTypeItem = "";
    },
    changeSelOperatPItem() {
      this.$emit("changeVal", this.selOperatPItem);
    },
    changeSelEventTypeItem() {
      this.$emit("changeSel", this.selEventTypeItem);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
.header {
  // padding-left: 30px;
  padding: 20px 0 20px 30px;
  text-align: left;
  .time {
    display: inline-block;
    margin-left: 30px;
    .select {
      display: inline-block;
    }
    input {
      width: 250px;
      height: 30px;
      padding-left: 5px;
      border: 1px solid rgb(230, 230, 230);
      color: rgb(161, 161, 161);
    }
  }
  .search {
    display: inline-block;
    margin-left: 10px;
    input {
      width: 280px;
      height: 30px;
      border: 1px solid rgba(230, 230, 230, 1);
      font-size: 12px;
      color: #a1a1a1;
      padding-left: 10px;
    }
    a {
      display: inline-block;
      width: 60px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background: rgba(242, 242, 242, 1);
      border: 1px solid rgba(230, 230, 230, 1);
      border-left: none;
    }
  }
  .operationPlatform,
  .eventType {
    display: inline-block;
    margin-left: 20px;
    select {
      width: 120px;
      height: 32px;
      border: 1px solid rgba(230, 230, 230, 1);
      outline: none;
      option {
        line-height: 30px;
        border: 1px solid rgba(230, 230, 230, 1);
      }
    }
  }
  .eventType {
    margin-left: 10px;
  }
}
</style>
